import {
    types
} from './types';

// import zxcvbn from 'zxcvbn';

import firebase, {
    googleAuthProvider,
    facebookAuthProvider
} from '../firebase/firebase';

import {
    activeDomain
} from '../constants';
import {
    addUserDataToClientAccount
} from '../utils/database/database-utils';
import {
    toArray
} from '../utils/lodashUtils';

import {
    notifyUser
} from './notification-actions';

const db = firebase.database();

export const getAuthStatus = () => async dispatch => {
    // Watch for changes in auth status...
    firebase.auth().onAuthStateChanged(firebaseUser => {
        if (firebaseUser) {
            // console.log('USER IS NOW LOGGED IN', firebaseUser);
            dispatch({
                type: types.FETCH_AUTH_DATA_SUCCESS,
                payload: firebaseUser
            })
        }
    });
};

export const startSignUp = (email, phoneNum, password, hasConsentedToMarketing, hasAgreedToTerms, firstName, lastName, provinceOfResidence, dateOfBirthTimestamp) => async dispatch => {
    // console.log('Signing up user with email:', email);
    if (email && password) {
        return new Promise(function (resolve, reject) {
            firebase.auth().createUserWithEmailAndPassword(email, password)
                .then((authResponse) => {
                    dispatch({
                        type: types.FETCH_AUTH_DATA_SUCCESS,
                        payload: authResponse
                    })
                    resolve(authResponse);

                    // console.log('%cCREATED NEW USER:','color: gold');
                    // console.log(authResponse.user);

                    addUserDataToClientAccount({
                        firstName,
                        lastName,
                        phoneNum,
                        provinceOfResidence,
                        dateOfBirthTimestamp,
                        userId: authResponse.user.uid,
                        hasConsentedToMarketing,
                        hasAgreedToTerms
                    });

                    console.log('LISTENING FOR VERIFICATION...');
                    _listenForEmailVerification(authResponse.user.uid)
                        .then((isVerified) => {
                            if (isVerified === true) {
                                // console.log('User has been verified');
                                // console.log(isVerified);
                                // show verificatioan toast on recipt of payload
                                dispatch({
                                    payload: isVerified,
                                    type: types.EMAIL_VERIFIED,
                                })
                            }
                        })
                        .catch(e => {
                            // console.log(e)
                        });
                })
                .catch(function (error) {
                    // Handle Errors here.
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    reject(error);
                    dispatch({
                        payload: error,
                        type: types.SIGN_UP_FAIL,
                    });
                });
        });
    }
}

export const startLogin = (provider, email = null, password = null, cb) => {
    if (provider === 'google') {
        return (dispatch) => {
            return firebase.auth().signInWithPopup(googleAuthProvider).then((user) => {
                    sessionStorage.setItem('user', JSON.stringify(user));
                    dispatch({
                        type: types.FETCH_AUTH_DATA_SUCCESS,
                        payload: user
                    })
                })
                .catch(e => {
                    // console.log(e)
                });
        }
    }
    if (provider === 'facebook') {
        return (dispatch) => {
            return firebase.auth().signInWithPopup(facebookAuthProvider).then((user) => {
                    dispatch({
                        payload: user,
                        type: types.FETCH_AUTH_DATA_SUCCESS,
                    })
                })
                .catch(e => {
                    // console.log(e)
                });
        }
    }
    if (provider === 'password' && email && password) {
        return (dispatch) => {
            return new Promise(function (resolve, reject) {
                // Remove any previous user data before login
                firebase.auth().signOut().then(() => {
                    localStorage.clear();
                    sessionStorage.clear();
                    firebase.auth().signInWithEmailAndPassword(email, password)
                        .then((user) => {
                            dispatch({
                                type: types.FETCH_AUTH_DATA_SUCCESS,
                                payload: user
                            })
                            resolve(user);
                        })
                        .catch(function (error) {
                            // Handle Errors here.
                            var errorCode = error.code;
                            var errorMessage = error.message;
                            dispatch({
                                payload: error,
                                type: types.LOG_IN_FAIL,
                            });
                            reject(error);
                        });
                });
            });
        }
    }
};

export const clearUserData = () => {
    return {
        type: types.CLEAR_USER_DATA
    }
}

export const logOut = (history, updateLocation) => async dispatch => {
    return new Promise(function (resolve, reject) {
        history.push('/');
        updateLocation('/');
        sessionStorage.removeItem('user');

        firebase.auth().signOut()
            .then(() => {
                // console.log('USER IS SIGNED OUT OF FIREBASE');
                dispatch({
                    type: types.LOG_OUT_SUCCESS
                });
                window.location.reload(true); // reloads the window to force new token to be used insread of cached token - essentially erasing all previous client data
                resolve();
            })
            .catch(e => {
                // console.log(e)
            });
    });
}

export const forgotPassword = (email) => async dispatch => {
    try {
        const emailAddress = email;

        // var actionCodeSettings = {
        //     url: `${activeDomain}/?email=` + emailAddress,
        // };

        // console.log('Running firebase password reset function...', email, emailAddress);

        let response = await firebase.auth().sendPasswordResetEmail(emailAddress)
        if (response) {
            // console.log('Response from password reset call:', response);

            // console.log('Password reset email sent successfully.');
            dispatch({
                type: types.PASSWORD_RESET_SUCCESS,
                payload: email
            });
        }

    } catch (e) {
        // console.error('Error: Could not send reset email.');
        dispatch({
            type: types.PASSWORD_RESET_FAIL,
            payload: null
        });
    }
}

export const resendVerification = (uid, email) => async dispatch => {
    try {
        const activationKey = db.ref(`sendNewActivationEmail`).push().key
        console.log('Email', email);
        db.ref(`sendNewActivationEmail/${activationKey}`).set({
                email,
                uid,
            })
            .then((res) => {
                // console.log('Activation Flag Set');
                console.log('listening for it', email);
                _listenForEmailVerification(uid)
                    .then((isVerified) => {
                        if (isVerified === true) {
                            // console.log('User has been verified');
                            // show verificatioan toast on recipt of payload

                            dispatch({
                                payload: isVerified, // TODO
                                type: types.EMAIL_VERIFIED,
                            })
                        }
                    })
                    .catch(console.log);
            })
            .catch(console.log);
    } catch (e) {
        // console.log('Error sending verification "resend',  e);
    }
}

export const checkPasswordStrength = (password) => async dispatch => {
    // console.log('PASSWORD ACTION CALLED');
    /* tslint:disable */
    import('zxcvbn')
        .then((zxcvbn) => {
            if (password) {
                let score = zxcvbn(password, ['cyno']).score;

                let passwordData = {
                    color: '',
                    message: '',
                    score: score,
                    suggestions: [],
                };
                if (password.length < 9) {
                    passwordData.suggestions.push('at least 9 characters');
                }
                if (!/^(?=.*[-+_!@#$%^&*.,?]).+$/.test(password)) {
                    passwordData.suggestions.push('symbols (e.g. _!@#$%^&*.,?-+)');
                }
                if (!/^(?=.*[a-z])(?=.*[A-Z]).+$/.test(password)) {
                    passwordData.suggestions.push('UPPERCASE & lowercase letters.');
                }
                if (!/^(?=.*\d).+$/.test(password)) {
                    passwordData.suggestions.push('numbers [0-9]?');
                }

                switch (score) {
                    case (0):
                        passwordData.message = 'Unsafe password: Very weak.';
                        passwordData.color = 'red';
                        break;
                    case (1):
                        passwordData.message = 'Unsafe password: Too weak.';
                        passwordData.color = 'orange';
                        break;
                    case (2):
                        passwordData.message = 'Unsafe password: Almost there.';
                        passwordData.color = 'yellow';
                        break;
                    case (3):
                        passwordData.message = `Safe password: That'll work.`;
                        passwordData.color = 'yellow-green';
                        break;
                    case (4):
                        passwordData.message = 'Safe password: Perfect.';
                        passwordData.color = 'green';
                        passwordData.suggestions = [];
                        break;
                }
                return dispatch({
                    payload: passwordData,
                    type: types.PASSWORD_STRENGTH_SCORE,
                });
            }

        })
        .catch(console.log)
    /* tslint:enable */
    return;
}

export const listenForEmailVerification = (uid) => async dispatch => {
    _listenForEmailVerification(uid)
        .then((isVerified) => {
            if (isVerified === true) {
                // console.log('User has been verified');
                // show verificatioan toast on recipt of payload
                dispatch({
                    payload: isVerified,
                    type: types.EMAIL_VERIFIED,
                })
            }
        })
        .catch(console.log);
}

export const _listenForEmailVerification = (uid) => {
    return new Promise(function (resolve, reject) {
        const verificationQuery = db.ref('/verifications').orderByChild('uid').equalTo(uid);
        verificationQuery.off();
        verificationQuery.on('value', snap => {
            snap.forEach(verificationSnap => {
                // console.log('%cLISTENING FOR NEW VERIFICATION DATA','color: greenyellow');
                // console.table(verificationSnap, verificationSnap.val(), verificationSnap.val().uid, uid);
                if (verificationSnap.val().uid === uid) {
                    // console.log('FOUND MATCHING VERIFICATION DATA');
                    // console.log('IS THE EMAIL VERIFIED?', verificationSnap.val().emailVerified);
                    const isEmailVerified = verificationSnap.val().emailVerified;
                    if (isEmailVerified === true) {
                        resolve(isEmailVerified);
                        // console.log('VERIFICATION HAS OCCURRED!');
                        // ONCE VERIFICATION IS COMPLETE REMOVE THE LISTENER
                        verificationQuery.off();
                        return;
                    }
                } else {
                    console.log('VERIFICATION FAILED');
                }
            })
        }, (e) => {
            console.log('Verification Error:', e, uid);
        })
    });
}

export const initAuthFlowRequiredStatus = () => {
    return {
        type: types.AUTH_FLOW_IN_PROCESS,
        payload: true
    }
}

export const endAuthFlowRequiredStatus = () => {
    return {
        type: types.AUTH_FLOW_IN_PROCESS,
        payload: false
    }
}

export const openLoginDialog = () => {
    const loginDialogOpenStatus = true;
    return {
        type: types.SET_LOGIN_DIALOG_OPEN,
        payload: loginDialogOpenStatus
    }
}

export const closeLoginDialog = () => {
    const loginDialogOpenStatus = false;
    return {
        type: types.SET_LOGIN_DIALOG_CLOSED,
        payload: loginDialogOpenStatus
    }
}

export const clearAuthErrors = () => {
    // console.log('CLEARING SERVER ERRORS');
    return {
        type: types.CLEAR_SERVER_ERROR,
        payload: null
    }
}

export const signInWithCustomToken = (customSignInToken) => async dispatch => {
    if (customSignInToken) {
        firebase.auth().signInWithCustomToken(customSignInToken)
            .then((user) => {
                dispatch({
                    type: types.TOKEN_SIGNIN,
                    payload: user
                });
                // dispatch({
                //     type: types.TOKEN_SIGNIN,
                //     payload: {user, signinTokenIsValid: true}
                // });
            })
            .catch(err => {
                // Handle Errors here.
                var errorCode = err.code;
                var errorMessage = err.message;
                console.log(`Error ${errorCode}: ${errorMessage}`)
            });
    }
};

const reauthenticate = (user) => {
    return new Promise(async (resolve, reject) => {
        let tempPassSnap = await db.ref(`clients/${user.uid}/tempPass`).once('value');
        if (tempPassSnap) {
            const tempPass = tempPassSnap.val();
            resolve(
                user.reauthenticateAndRetrieveDataWithCredential(
                    firebase.auth.EmailAuthProvider.credential(user.email, tempPass)
                )
            )
        } else {
            throw new Error('Could not find user to reset password.');
        }
    });
}

const dispatchSuccessfulActivation = (dispatch, resolve) => {
    dispatch({
        type: types.ACCOUNT_ACTIVATION_SUCCESS,
        payload: true
    });
    resolve(true);
}

export const setNewPassword = (newPassword) => async dispatch => {
    return new Promise(async (resolve, reject) => {
        const user = firebase.auth().currentUser;
        try {
            await reauthenticate(user);
        } catch (error) {
            console.log('Reauthentication Error:', error);
        }

        await user.updatePassword(newPassword)
            .then(function () {
                console.log('Password has been reset.'); // Should email user to let them know their password has been reset.
                dispatchSuccessfulActivation(dispatch, resolve);
            })
            .catch(async function (error) {
                console.log('Could not reset password.', error);

                if (error.code == 'auth/requires-recent-login') {
                    try {
                        await reauthenticate(user);

                        user.updatePassword(newPassword)
                            .then(() => {
                                console.log('Password has been reset.'); // Should email user to let them know their password has been reset. "We detected that your account password has been changed. If you just activated your account or reset your password you can ignore this message. Otherwise, contact us as your account may have been compromised. Support link here. Send date time and location"

                                dispatchSuccessfulActivation(dispatch, resolve);
                            })
                            .catch(e => {
                                console.log('Second password update auth error', e);
                                // SHOW ERROR TO USER
                                dispatch(notifyUser({
                                    message: 'ERROR: Could not reset password. Please contact technical support for assistance.',
                                    textColor: 'white',
                                    visible: true,
                                }));
                                resolve(false);
                            })
                    } catch (error) {
                        console.log('Reauthentication Error :', error);
                    }
                } else {
                    resolve(false);
                }
            });
        console.log('update should be done!');
        //reject();
    });
}

export const checkActivationCode = (activationCodeFromUser) => async dispatch => {
    return new Promise(async (resolve, reject) => {
        const user = firebase.auth().currentUser;
        const userId = user.uid;
        const codeSnap = await db.ref(`/clients/${userId}/activationCode`).once('value');
        const activationCodeFromDB = codeSnap.val();
        if (activationCodeFromUser === activationCodeFromDB) {
            // updates = {};
            // updates[`/clients/${userId}/codeActivated`] = true;
            // db.ref().update(updates, error => {
            //     error
            //         ? console.log(error)
            //         : console.log('successful activation');
            // });
            dispatch({
                type: types.VALID_ACTIVATION_CODE,
                payload: true
            })
            resolve(true);
        } else {
            console.log('Wrong code');
            resolve(false);
        }
    });
}

export const completeAccountActivationForm = (formData) => async dispatch => {
    const user = firebase.auth().currentUser;
    const userId = user.uid;
    let updates = {};
    Object.keys(formData).forEach(activationFormParameter => {
        if (formData[activationFormParameter] !== null && typeof formData[activationFormParameter] === 'object') {
            Object.keys(formData[activationFormParameter]).forEach(formParameterSubField => {
                updates[`/clients/${userId}/${activationFormParameter}/${formParameterSubField}`] = formData[activationFormParameter][formParameterSubField];
            })
        } else {
            updates[`/clients/${userId}/${activationFormParameter}`] = formData[activationFormParameter];
        }
    });
    //console.log('updates', updates);
    db.ref().update(updates, error => {
        if (error) {
            console.log('FIREBASE ERROR', error, 'UPDATES ARE:', updates);
        } else {
            console.log('Update succesful');

            // TODO: HERE WE WANT TO FIRE A CLOUD FUNC THAT ERASES THE PENDING CLIENT

            db.ref(`activatedPendingAccount/${user.uid}/activated`).set(true, (error) => {
                if (!error) console.log('set activated pending account')
                if (error) console.log('FIREBASE ERROR', error)
            });
            // get comapnyId by mapping over activation requiests and the activation ID by using the uid TODO

            dispatch({
                type: types.ACTIVATION_FORM_SUCCESS,
                payload: true
            })
        }
    });
}


export const validateEmailWithMailgun = (emailToValidate) => async dispatch => {
    let emailValidationRef = db.ref(`/validate`);
    emailValidationRef.set({
        email: emailToValidate
    });
    return new Promise((resolve, reject) => {
        let validationResultRef = db.ref(`/validate/email`);
        validationResultRef.on('value', validationSnap => {
                if (validationSnap.val() !== emailToValidate) {
                    console.log("Is email valid? ", validationSnap.val());
                    resolve(validationSnap.val());
                    validationResultRef.off();
                }
            },
            (err) => {
                console.log('FIREBASE ERROR', err);
                validationResultRef.off();
            });
    });
};


// WEBPACK FOOTER //
// ./src/js/actions/auth-actions.js